


















import { Component, mixins } from 'nuxt-property-decorator';
import ReferralPrizeMixin from '~/components/partials/referral/ReferralInvite/referralPrizeMixin';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

import ReferralIcon from '~/assets/svg/referral-symbol.vue.svg';

@Component<UserMenuMobileSubMenuReferralButton>({
  components: {
    BravadoButtonV3,
    ReferralIcon,
  },
})
export default class UserMenuMobileSubMenuReferralButton extends mixins(ReferralPrizeMixin) {
  handleReferralOpen() {
    this.$modal.showWithRoute('REFERRAL_MODAL');
  }
}
